export default (function (){
    /*
     * Thanks to Louis Hoebregts, https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
     */

    const defaults = {
        selectors: {
            element: "details.revealableContent",
            summary: ".revealableContent-summary",
            content: ".revealableContent-content",
        },
        durations: {
            in: 150,
            out: 300,
        }
    };

    let items = [];

    function init(options) {

        const elements = document.querySelectorAll(defaults.selectors.element);

        for (let i = 0; i < elements.length; i++) {
            items.push(new Revealer(elements[i], options));
        }

    }

    const closeAll = function() {

        for (let i = 0; i < items.length; i++) {
            items[i].close();
        }

    }

    const openAll = function() {

        for (let i = 0; i < items.length; i++) {
            items[i].open();
        }

    }

    const Revealer = function(element, options) {

        if (typeof element.animate !== "function") {
            console.warn("revealableContent: Browser doesn’t support method animate().");
            return;
        }

        this.settings = Object.assign({}, defaults, options);

        this.element = element;

        this.summary = this.element.querySelector(this.settings.selectors.summary);
        this.content = this.element.querySelector(this.settings.selectors.content);

        this.animation = null;
        this.isOpen = false;
        this.isClosing = false;
        this.isExpanding = false;

        this.summary.addEventListener(
            "click",
            (e) => {
                e.preventDefault();
                this.toggle() ;
            }
        );

        return this;

    }

    Revealer.prototype.toggle = function() {

        this.isOpen = this.element.hasAttribute("open");

        if (this.isClosing || ! this.isOpen) {
            this.open();
        } else if (this.isExpanding || this.isOpen) {
            this.close();
        }

    }

    Revealer.prototype.close = function() {

        if (! this.isOpen) {
            return;
        }

        this.element.setAttribute("closing", true);

        this.element.style.overflow = "hidden";

        this.isClosing = true;

        const startHeight = this.getStartHeight(this.element.offsetHeight),
              endHeight = this.getEndHeight(this.summary.offsetHeight);

        if (this.animation) {
            this.animation.cancel();
        }

        this.animation = this.element.animate(
            {
                height: [startHeight, endHeight]
            },
            {
                duration: this.settings.durations.out,
                easing: "ease"
            }
        );

        this.animation.onfinish = () => this.update(false);
        this.animation.oncancel = () => this.isClosing = false;

    }

    Revealer.prototype.getEndHeight = function(height) {

        const styles = window.getComputedStyle(this.element);

        const borderTopWidth = parseFloat(styles['borderTop']),
              borderBottomWidth = parseFloat(styles['borderBottom']);

        height += borderTopWidth + borderBottomWidth;

        return `${height}px`;

    }

    Revealer.prototype.getStartHeight = function(height) {

        return `${height}px`;

    }

    Revealer.prototype.open = function() {

        if (this.isOpen) {
            return;
        }

        this.element.style.overflow = "hidden";
        this.element.style.height = `${this.element.offsetHeight}px`;

        this.element.setAttribute("open", true);

        window.requestAnimationFrame(
            () => this.expand()
        );

    }

    Revealer.prototype.expand = function () {

        this.isExpanding = true;

        const startHeight = this.getStartHeight(this.element.offsetHeight),
              endHeight = this.getEndHeight(this.summary.offsetHeight + this.content.offsetHeight);

        if (this.animation) {
            this.animation.cancel();
        }

        this.animation = this.element.animate(
            {
                height: [startHeight, endHeight]
            },
            {
                duration: this.settings.durations.in,
                easing: "ease"
            }
        );

        this.animation.onfinish = () => this.update(true);
        this.animation.oncancel = () => this.isExpanding = false;

    }

    Revealer.prototype.update = function(open) {

        this.isOpen = open;

        if (this.isOpen) {
            this.element.setAttribute("open", true);
        } else {
            this.element.removeAttribute("open");
            this.element.removeAttribute("closing");
        }

        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.element.style.height = "";
        this.element.style.overflow = "";

    }

    return {
        init: init,
        closeAll: closeAll,
        openAll: openAll,
    }

})();
